import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/base/Seo";
import PageHeader from "@/components/feature/PageHeader";

const heroImage =
  "https://readdy.ai/api/search-image?query=Soft%20abstract%20editorial%20background%20of%20warm%20paper%20textures%20and%20legal%20documents%20neatly%20arranged%20on%20a%20light%20desk%20with%20a%20pen%20and%20a%20small%20heart%20symbol%2C%20minimalist%20clean%20composition%2C%20natural%20soft%20daylight%2C%20calm%20professional%20mood%2C%20high%20detail&width=1600&height=500&seq=humanity59-mentions-hero&orientation=landscape";

const sections = [
  {
    title: "Éditeur du site",
    items: [
      {
        label: "Dénomination",
        value: "Association Humanity59",
      },
      {
        label: "Forme juridique",
        value: "Association loi 1901 à but non lucratif",
      },
      {
        label: "Siège social",
        value: "12 rue de la Solidarité, 59000 Lille, France",
      },
      {
        label: "Numéro RNA",
        value: "W591000000",
      },
      {
        label: "SIRET",
        value: "000 000 000 00000",
      },
      {
        label: "Email",
        value: "contact@humanity59.com",
      },
      {
        label: "Téléphone",
        value: "06 18 23 21 63",
      },
    ],
  },
  {
    title: "Directeur de la publication",
    items: [
      {
        label: "Responsable",
        value: "Le président de l'association Humanity59",
      },
      {
        label: "Contact",
        value: "contact@humanity59.com",
      },
    ],
  },
  {
    title: "Hébergement du site",
    paragraphs: [
      "Le site humanity59.com est hébergé par un prestataire d'hébergement dont les coordonnées sont disponibles sur simple demande auprès de l'association. L'hébergeur assure le stockage et la mise à disposition du site dans le respect des réglementations en vigueur.",
    ],
  },
  {
    title: "Propriété intellectuelle",
    paragraphs: [
      "L'ensemble des contenus présents sur ce site (textes, images, photographies, logos, graphismes, vidéos) est protégé par le droit d'auteur et la propriété intellectuelle. Toute reproduction, représentation, modification ou diffusion, totale ou partielle, sans autorisation écrite préalable de l'association Humanity59 est strictement interdite.",
      "Les marques et logos cités sur le site sont la propriété de leurs détenteurs respectifs.",
    ],
  },
  {
    title: "Responsabilité",
    paragraphs: [
      "L'association Humanity59 s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, elle ne saurait être tenue responsable des omissions, inexactitudes ou carences dans la mise à jour, qu'elles soient de son fait ou du fait de tiers partenaires.",
      "Les liens hypertextes présents sur le site peuvent orienter les utilisateurs vers des sites externes dont le contenu ne saurait engager la responsabilité de l'association.",
    ],
  },
  {
    title: "Crédits",
    paragraphs: [
      "Les photographies et visuels utilisés sur ce site sont issus de banques d'images libres de droits ou de la propre production de l'association. Conception et réalisation du site : Humanity59.",
    ],
  },
  {
    title: "Droit applicable",
    paragraphs: [
      "Le présent site est soumis au droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.",
    ],
  },
];

export default function MentionsLegales() {
  return (
    <div className="min-h-screen flex flex-col">
      <Seo
        title="Mentions légales | Humanity59"
        description="Mentions légales du site Humanity59 : éditeur, hébergement, propriété intellectuelle et responsabilité de l'association humanitaire."
        keywords="mentions légales, association humanitaire, éditeur, propriété intellectuelle"
        path="/mentions-legales"
      />
      <Header />
      <main className="flex-1">
        <PageHeader
          title="Mentions légales"
          subtitle="Informations légales relatives à l'édition et à l'exploitation du site Humanity59."
          image={heroImage}
        />

        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <p className="text-sm text-foreground-500">
              Dernière mise à jour : 19 août 2026
            </p>

            <div className="mt-8 space-y-12">
              {sections.map((section) => (
                <article key={section.title}>
                  <h2 className="font-heading text-2xl font-bold text-foreground-950">
                    {section.title}
                  </h2>

                  {section.items ? (
                    <dl className="mt-5 rounded-lg border border-background-200 bg-background-50 divide-y divide-background-100">
                      {section.items.map((item) => (
                        <div
                          key={item.label}
                          className="flex flex-col sm:flex-row gap-1 sm:gap-6 px-5 py-4"
                        >
                          <dt className="sm:w-44 shrink-0 text-sm font-medium text-foreground-500">
                            {item.label}
                          </dt>
                          <dd className="text-sm font-semibold text-foreground-950">
                            {item.value}
                          </dd>
                        </div>
                      ))}
                    </dl>
                  ) : (
                    <div className="mt-4 space-y-4">
                      {section.paragraphs.map((paragraph, index) => (
                        <p
                          key={index}
                          className="text-base text-foreground-600 leading-relaxed"
                        >
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  )}
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}